import React, { useLayoutEffect, useState } from 'react';
import clsx from 'clsx';
import { isEven } from '@helpers/utils';

import Container from '@common/Container';
import Heading from '@common/Heading';
import Section from '@common/Section';
import Row from '@common/Row';
import Img from '@common/Image';
import Link from '@common/Link';

const Default = ({ data }) => {
  const {
    title,
    showTitle,
    list,
    bgColour
  } = data;
  const [spacing, setSpacing] = useState('col');
  useLayoutEffect(() => {
    if (list === null) return;
    let spacing = 'col';
    const longList = list.length > 2;
    if (longList && isEven(list.length)) {
      spacing = 'col-6 col-lg-3';
    } else if (longList && !isEven(list.length)) {
      spacing = 'col-12 col-lg-4'
    }
    setSpacing(spacing);
  }, [list])
  return (
    <Section className={clsx({[`bg-${bgColour} py-5`]: bgColour })}>
      <Container>
        {(showTitle && title) && <Heading type='h2' className='mx-auto mb-4 col-lg-10 text-center'>{title}</Heading>}
        <Row className={clsx('justify-content-between')}>
          {list && list.map((item, index) => (
            <Link key={index} to={item.link} className={clsx('my-3', spacing)}>
              {item.image &&
                <div className={`d-flex justify-content-center`}>
                  <Img
                    image={item.image.gatsbyImageData}
                    file={item.image.file}
                    alt={item.image.description}
                    style={{ maxHeight: '150px' }}
                    imgStyle={{ objectFit: 'contain' }}
                  />
                </div>
              }
              {item.title && <div className='text-center text-black mt-3'>{item.title}</div>}
              {item.subtitle && <div className='text-center d-block'>{item.subtitle}</div>}
            </Link>
          ))}
        </Row>
      </Container>
    </Section>
  )
}

export default Default
